import React, { Component } from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';

import formStyles from '../form/Form.css';
import TextField from '../form/TextField';
import CheckboxField from '../form/CheckboxField';
import AddressField from '../form/AddressField';
import PhoneField from '../form/PhoneField';
import EmailField from '../form/EmailField';

class JusticeField extends Component {
  render() {
    const { model, isAuthor, value } = this.props;

    return (
      <div>
        <CheckboxField
          model={`${model}.withJustice`}
          label={
              value.kind === 'natural' ?
                'Cochez cette case si ' +
                (isAuthor ? 'vous êtes placé ' : 'la personne est placée ') +
                'sous mesure de justice (tutelle, curatelle, sauvegarde de ' +
                'justice)' :
                'Cochez cette case si ' + (isAuthor ? 'votre ' : 'la ') +
                'société est en cours de procédure collective (sauvegarde, ' +
                'redressement judiciaire)'
            }
        />

        {value.withJustice &&
          <div>
            <div className={formStyles.title}>
              {value.kind === 'natural' ?
                'Tuteur / Curateur' :
                'Liquidateur / Administrateur judiciaire'
              }
            </div>

            <TextField
              model={`${model}.justice.lastName`}
              label="Nom"
              required
            />

            <TextField
              model={`${model}.justice.firstName`}
              label="Prénom"
              required
            />

            <AddressField
              model={`${model}.justice.address`}
              label="Adresse"
              required
            />

            <EmailField
              model={`${model}.justice.email`}
              label="Email"
              required
            />

            <PhoneField
              model={`${model}.justice.phoneNumber`}
              label="Téléphone"
              required
            />
          </div>
        }
      </div>
    );
  }
}

export default connect((state, props) => ({
  value: get(state, props.model),
}))(JusticeField);



/** WEBPACK FOOTER **
 ** ./client/act/JusticeField.js
 **/